var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#EEF1FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.19 12H17.81C14.17 12 12 14.17 12 17.81V26.18C12 29.83 14.17 32 17.81 32H26.18C29.82 32 31.99 29.83 31.99 26.19V17.81C32 14.17 29.83 12 26.19 12ZM17.67 15.5C17.67 15.09 18.01 14.75 18.42 14.75C18.83 14.75 19.17 15.09 19.17 15.5V19.4C19.17 19.81 18.83 20.15 18.42 20.15C18.01 20.15 17.67 19.81 17.67 19.4V15.5ZM19.5228 26.4313C19.3194 26.5216 19.17 26.7132 19.17 26.9358V28.5C19.17 28.91 18.83 29.25 18.42 29.25C18.01 29.25 17.67 28.91 17.67 28.5V26.9358C17.67 26.7132 17.5206 26.5216 17.3172 26.4311C16.3628 26.0064 15.7 25.058 15.7 23.95C15.7 22.45 16.92 21.22 18.42 21.22C19.92 21.22 21.15 22.44 21.15 23.95C21.15 25.0582 20.4791 26.0066 19.5228 26.4313ZM26.33 28.5C26.33 28.91 25.99 29.25 25.58 29.25C25.17 29.25 24.83 28.91 24.83 28.5V24.6C24.83 24.19 25.17 23.85 25.58 23.85C25.99 23.85 26.33 24.19 26.33 24.6V28.5ZM25.58 22.77C24.08 22.77 22.85 21.55 22.85 20.04C22.85 18.9318 23.5209 17.9834 24.4772 17.5587C24.6806 17.4684 24.83 17.2768 24.83 17.0542V15.5C24.83 15.09 25.17 14.75 25.58 14.75C25.99 14.75 26.33 15.09 26.33 15.5V17.0642C26.33 17.2868 26.4794 17.4784 26.6828 17.5689C27.6372 17.9936 28.3 18.942 28.3 20.05C28.3 21.55 27.08 22.77 25.58 22.77Z",
    fill: "#405EDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.bc7770957c0366081945d6b1075155d4.svg";
export { ForwardRef as ReactComponent };